// removed by extract-text-webpack-plugin
module.exports = {"item":"RouteTabItem__item","active":"RouteTabItem__active","fadeIn":"RouteTabItem__fadeIn"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/components/RouteTabItem/RouteTabItem.css
// module id = 1274
// module chunks = 8